import { SEO } from "@/components/SEO"
import { Separator } from "@/components/ui/separator"

export function TermsPage() {
  return (
    <>
      <SEO
        title="Terms of Service"
        url="/terms"
        description="Terms of Service for Prediction Mining Game. Read about user eligibility, risks, wallet security, and legal disclaimers."
        keywords="terms of service, legal, crypto regulations, user agreement"
        noindex={true}
      />
      <div className="container py-16 max-w-3xl">
      <h1 className="text-3xl font-bold mb-2">Terms of Service</h1>
      <p className="text-muted-foreground mb-8">Last updated: January 2025</p>

      <div className="prose prose-neutral dark:prose-invert max-w-none">
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">1. Acceptance of Terms</h2>
          <p className="text-muted-foreground mb-4">
            By accessing or using WELEPHANT, you agree to be bound by these Terms of Service.
            If you do not agree to these terms, please do not use the service.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">2. Description of Service</h2>
          <p className="text-muted-foreground mb-4">
            WELEPHANT is a decentralized gaming application built on the BNB Chain.
            The service allows users to participate in mining rounds by staking cryptocurrency.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">3. Eligibility</h2>
          <p className="text-muted-foreground mb-4">
            You must be at least 18 years old and legally permitted to participate in
            cryptocurrency activities in your jurisdiction to use this service.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">4. Risks</h2>
          <p className="text-muted-foreground mb-4">
            Participation in WELEPHANT involves financial risk. You may lose some or all
            of your staked cryptocurrency. Only stake what you can afford to lose.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">5. No Guarantee</h2>
          <p className="text-muted-foreground mb-4">
            We make no guarantees regarding the outcome of any round or the performance
            of the WELEPHANT token. Past performance does not indicate future results.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">6. Modifications</h2>
          <p className="text-muted-foreground mb-4">
            We reserve the right to modify these terms at any time. Continued use of
            the service after changes constitutes acceptance of the new terms.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">7. User Conduct</h2>
          <p className="text-muted-foreground mb-4">
            You agree to use the in-game chat and all platform features respectfully.
            Prohibited conduct includes harassment, hate speech, spam, impersonation,
            sharing malicious links, and any attempt to manipulate or exploit the game
            mechanics. We reserve the right to restrict access for violations.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">8. Wallet Security</h2>
          <p className="text-muted-foreground mb-4">
            You are solely responsible for the security of your wallet, private keys,
            and seed phrases. WELEPHANT will never ask for your private keys. Lost or
            compromised wallet credentials cannot be recovered by us.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">9. Disclaimer of Warranties</h2>
          <p className="text-muted-foreground mb-4">
            WELEPHANT is provided "as-is" without warranties of any kind, express or
            implied. We do not warrant that the service will be uninterrupted, error-free,
            or secure. Smart contracts may contain bugs or vulnerabilities, and blockchain
            transactions are irreversible. You acknowledge the inherent risks of interacting
            with smart contracts and decentralized protocols.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">10. Limitation of Liability</h2>
          <p className="text-muted-foreground mb-4">
            To the maximum extent permitted by law, WELEPHANT and its operators shall not
            be liable for any damages whatsoever, including loss of funds, arising from
            your use of the service. Your current round stake may result in total loss,
            and autoplay features may be cancelled at any time without notice.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">11. Indemnification</h2>
          <p className="text-muted-foreground mb-4">
            You agree to indemnify and hold harmless WELEPHANT, its operators, and all
            other participants from any claims, damages, or expenses arising from your
            use of the service, violation of these terms, or infringement of any third-party
            rights.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">12. Tax Responsibility</h2>
          <p className="text-muted-foreground mb-4">
            You are solely responsible for determining and fulfilling any tax obligations
            arising from your participation in WELEPHANT, including reporting gains or
            losses. We do not provide tax advice.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">13. Third-Party Services</h2>
          <p className="text-muted-foreground mb-4">
            WELEPHANT integrates with third-party services including wallet providers,
            blockchain networks, and related infrastructure. We are not responsible for
            the availability, security, or performance of these services. Your use of
            third-party services is subject to their respective terms.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">14. Governing Law</h2>
          <p className="text-muted-foreground mb-4">
            These terms shall be governed by and construed in accordance with the laws
            of the United States, without regard to conflict of law principles.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">15. Dispute Resolution</h2>
          <p className="text-muted-foreground mb-4">
            By using WELEPHANT, you agree that any disputes will be resolved through
            binding arbitration at a venue of our choosing. You waive any right to a
            jury trial, class actions, class arbitrations, or representative proceedings.
            Use of this service is at your own risk.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">16. Contact</h2>
          <p className="text-muted-foreground mb-4">
            For questions about these terms, contact us at contact@welephant.xyz.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">17. Severability</h2>
          <p className="text-muted-foreground mb-4">
            If any provision of these terms is found to be unenforceable, the remaining
            provisions shall continue in full force and effect.
          </p>
        </section>
      </div>
    </div>
    </>
  )
}
